module.exports = __webpack_public_path__ + "img/firefox.8433c877.svg";